export default __webpack_public_path__ + "static/media/Groovy.c8219ebf.png";